import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const useVideos = () =>
  useQuery({ queryKey: ["videos"], queryFn: () => api.get("/videos").then((r) => r.data) });

export const HeroVideo = () => {
  const { data = [] } = useVideos();
  const landscape = data.find((v) => v.type === "landscape");
  return (
    <section className="max-w-5xl mx-auto px-5 sm:px-8 -mt-2 pt-8">
      <div
        data-testid="hero-landscape-video"
        className="aspect-video rounded-2xl overflow-hidden border-2 border-[#E2705A]/40 shadow-2xl shadow-[#121E2B]/30 bg-black"
      >
        {landscape ? (
          <iframe
            className="w-full h-full"
            src={`https://www.youtube.com/embed/${landscape.youtube_id}?rel=0`}
            title={landscape.title || "R.O.A.N Initiative video"}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-[#FDFBF7]/60 font-type text-sm">
            Landscape video coming soon
          </div>
        )}
      </div>
    </section>
  );
};
